import { loaderService } from "../../../common/custom-loader/loader-service";
import { authKey, GET_WORKFLOW_REQUEST_DETAILS, PROCESS_WORK_FLOW, PROCESS_MULTIPLE_WORK_FLOW, GET_WORKFLOW_ACTION_TAKEN_REQUEST_DETAILS } from '../../../common/URLs';

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import apiClient from "../../../axios";

export const getWorkflowRequestDetails = (selectedReuqest, setWorkFlowRequestDetails, sent) => {
  loaderService.showLoader();
    apiClient
      .post(GET_WORKFLOW_REQUEST_DETAILS + `?requestNumber=${selectedReuqest}&view=${sent}&currentOwner=${localStorage.getItem('role')}`, 
            {
                },
           {
                headers: {
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                          }
            }, null
      )
      .then((response) => {
        setWorkFlowRequestDetails(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  export const getWorkflowActionTknRqDetails = (selectedReuqest, setWorkFlowRequestDetails, sent) => {
    loaderService.showLoader();
      apiClient
        .post(GET_WORKFLOW_ACTION_TAKEN_REQUEST_DETAILS + `?requestNumber=${selectedReuqest}&view=${sent}&currentOwner=${localStorage.getItem('role')}`, 
              {
                  },
             {
                  headers: {
                  Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                            }
              }, null
        )
        .then((response) => {
          setWorkFlowRequestDetails(response.data);
          loaderService.hideLoader();
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader();
        });
    }

  export const processWorkFlow = (applicationNumber, action, remark, setProcessedWorkFlowResponse) => {
    loaderService.showLoader();
    apiClient
      .post(PROCESS_WORK_FLOW + `?applicationNumber=${applicationNumber}&action=${action}&remarks=${remark}&userRole=${localStorage.getItem('role')}&approverName=${localStorage.getItem('userName')}&approverRole=${localStorage.getItem('role')}`, 
            {
                },
           {
                headers: {
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                          }
            }, null
      )
      .then((response) => {
        setProcessedWorkFlowResponse(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  export const processMultipleWorkFlow = (finalSubmissionRateArr, setRateCardResponse) => {
    loaderService.showLoader();
    apiClient
      .post(PROCESS_MULTIPLE_WORK_FLOW , 
        {
          "processWorkflowRequest": finalSubmissionRateArr.map((item) => ({...item, userRole: localStorage.getItem('role'), approverName: localStorage.getItem('userName'),
            approverRole: localStorage.getItem('role')}))
        },
           {
                headers: {
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                          }
            }, null
      )
      .then((response) => {
        setRateCardResponse(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }